import {
    SET_RELATIONSHIP,
    SET_RELATIONSHIPNAME,
    SET_RELATIONSHIPREMARK,
    GET_ALLOWED_RELATIONSHIPS_REQUEST,
    GET_ALLOWED_RELATIONSHIPS_SUCCESS,
    GET_ALLOWED_RELATIONSHIPS_FAILURE,
    CLEANUP,
} from "./selectRelationshipType";
  
const initialState = {
    loading: false,
    relationship: null,
    relationshipName: null,
    relationshipRemark: null,
    allowedRelationships: [],
    error: "",
};
  
const selectRelationshipReducer = (state = initialState, action) => {
    switch (action.type) {
        case CLEANUP: {
            return initialState;
        }
  
        case SET_RELATIONSHIP: {
            return {
            ...state,
            relationship: action.relationship,
            };
        }
    
        case SET_RELATIONSHIPNAME: {
            return {
            ...state,
            relationshipName: action.relationshipName,
            };
        }
    
        case SET_RELATIONSHIPREMARK: {
            return {
            ...state,
            relationshipRemark: action.relationshipRemark,
            };
        }
    
        case GET_ALLOWED_RELATIONSHIPS_REQUEST: {
            return {
            ...state,
            loading: true,
            };
        }
    
        case GET_ALLOWED_RELATIONSHIPS_SUCCESS: {
            return {
            ...state,
            loading: false,
            allowedRelationships: action.payload,
            error: "",
            };
        }
    
        case GET_ALLOWED_RELATIONSHIPS_FAILURE: {
            return {
            ...state,
            loading: false,
            allowedRelationships: [],
            error: action.payload,
            };
        }
    
        default:
            return state;
    }
};
  
export default selectRelationshipReducer;
  